import React from 'react';

export default () => (
    <svg width="20" height="21">
        <g fill="none" fill-rule="evenodd" transform="translate(0 .329)" stroke="#DA4224" stroke-width="1.4">
            <g stroke-linecap="round">
                <path d="M6.806 13.012l6.202-6.202M6.806 6.81l6.202 6.202" />
            </g>
            <circle cx="10" cy="10" r="9" />
        </g>
    </svg>
);
